import { Button, Dialog, DialogContent, DialogTitle, Grid, makeStyles } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { createChallenge } from '../api';

import { ChallengeForm } from './ChallengeForm';

export const ChallengeCreate = ({ fetchChallenges }) => {
	const [showCreateDialog, setShowCreateDialog] = React.useState(false);
	const { merchantId } = useSelector(state => state.merchants.filter);
	const classes = useStyles();

	const optimisticCreateChallenge = async challenge => {
		if (challenge) {
			challenge.ts = Date.now();
			challenge.merchantId = merchantId;

			await createChallenge({ announcement: challenge });
			fetchChallenges();
		}
		setShowCreateDialog(false);
	};

	return (
		<>
			<Grid container>
				<Button
					variant='contained'
					color='secondary'
					disabled={merchantId === 'all'}
					onClick={() => setShowCreateDialog(true)}
				>
					<Add />
					Create a challenge
				</Button>
			</Grid>
			<Dialog
				classes={{
					paperWidthSm: classes.dialog,
				}}
				open={showCreateDialog}
				onClose={(event, reason) => {
					if (reason !== 'backdropClick') {
						setShowCreateDialog(false)
					}
				}}
				style={{ borderRadius: 10, maxWidth: 'unset' }}
			>
				<DialogTitle>Create a challenge</DialogTitle>
				<DialogContent className={classes.content}>
					<ChallengeForm merchantId={merchantId} onClose={optimisticCreateChallenge} />
				</DialogContent>
			</Dialog>
		</>
	);
};

const useStyles = makeStyles(() => ({
	dialog: {
		maxWidth: 'unset',
		borderRadius: 10,
	},
	content: {
		marginBottom: 12,
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#F5F5F5',
		},
		'&::-webkit-scrollbar': {
			width: '4px',
			backgroundColor: '#F5F5F5',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#ccc',
		},
	},
}));
